import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

import { AutorizacionesAccordionEfector } from "./Accordions/AutorizacionesAccordionEfector";
import { AutorizacionesAccordionPrescriptor } from "./Accordions/AutorizacionesAccordionPrescriptor";
import { AutorizacionesAccordionMateriales } from "./Accordions/AutorizacionesAccordionMateriales";
import LetterX from "../UI/LetterX";

import {
  getEfectorInstitucional,
  deletePractica,
  setearValorEnPractica,
} from "../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_PRACTICAS_ESTADOS, AUTORIZACIONES_SOLICITUDES_ESTADOS, AUTORIZACIONES_TIPO_EFECTOR, TIPOS_AUTORIZACIONES } from "../../../utils/constants";
import { ModalCantidadPracticasPeriodo } from "./ModalCantidadPracticasPeriodo";
import { PracticaNroAutorizacion } from "./PracticaNroAutorizacion";
import { useState } from "react";

const PracticaTipoInternacionDomiciliaria = (props) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const { estadoSolicitudes, solicitudSeleccionada } = useSelector((state) => state.autorizaciones);

  const disabledProp = (props.esDenunciaInternacion ||
    parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA ||
    parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES ||
    props.disabled) ? true : false;

  return (
    <div style={{ marginBottom: "2.8rem" }}>
      <div
        style={{
          padding: "1rem",
          marginTop: "1.5rem",
          marginBottom: "0.5rem",
          marginRight: "1rem",
          marginLeft: "1rem",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {(props.disabled || props.permisoIngresoInterDom) && (
          <LetterX
            deleteFunction={() => {
              dispatch(deletePractica(props.practica?.idCodNom));
            }}
            styles={{
              cursor: "pointer",
              position: "relative",
              top: "0.25rem",
              marginRight: "0.5rem",
            }}
          />
        )}
        {props.desdeAuditar && <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem" }}>
          {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
        </Typography>}
        {(props.practica?.practica?.nivelAutorizacion === 0 || props.practica?.practica?.nivelAutorizacion === 1)
          && !props.desdeAuditar && <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", color: "#10b04b" }}>
            {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
          </Typography>}
        {(props.practica?.practica?.nivelAutorizacion === 2 || props.practica?.practica?.nivelAutorizacion === 3)
          && !props.desdeAuditar && <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", color: "#c43e1f" }}>
            {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
          </Typography>}
        <Button
          color="primary"
          variant="contained"
          style={{ marginLeft: 35, marginRight: props.desdeAuditar ? -35 : 0 }}
          onClick={() => setOpenModal(true)}
        >
          Cantidad Periodo
        </Button>
        {openModal && (
          <ModalCantidadPracticasPeriodo
            open={openModal}
            disabled={props.permisoIngresoInterDom}
            practica={props.practica}
            onClose={() => setOpenModal(false)}
            permiteAgregarPracticaPeriodo={props.permiteAgregarPracticaPeriodo}
            fechaInicioInternacion={new Date(solicitudSeleccionada.fechaIngreso)}
            esOxigeno={ solicitudSeleccionada.idTipoSolicitud ===
              TIPOS_AUTORIZACIONES.OXIGENO ? true: false}
              desdeAuditar={props.desdeAuditar}
          />
        )}
      </div>
      <>
        {props.desdeAuditar && (
          <RadioGroup
            row
            style={{ justifyContent: "space-evenly" }}
            value={props.practica?.idEstadoPractica?.toString()}
            onChange={(e) => {
              dispatch(
                setearValorEnPractica(
                  props.practica?.idCodNom,
                  "idEstadoPractica",
                  parseInt(e.target.value)
                )
              );

              if (props.evaluarPracticasMateriales && parseInt(e.target.value) === AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO)
                props.evaluarPracticasMateriales();
            }}
          >
            <FormControlLabel
              label={"Autorizada"}
              value={AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO.toString()}
              control={<Radio />}
              disabled={disabledProp}
            />
            <FormControlLabel
              label={"Gestión"}
              value={AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION.toString()}
              control={<Radio />}
              disabled={disabledProp}
            />
            <FormControlLabel
              label={"Rechazada"}
              value={AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO.toString()}
              control={<Radio />}
              disabled={disabledProp}
            />
          </RadioGroup>
        )}
        <FormGroup>
          <FormControlLabel
            style={{
              marginLeft: 50,
              marginTop: !props.desdeAuditar && -35,
              marginBottom: 25,
            }}
            control={
              <Checkbox
                checked={!!props.practica?.recuperoSur}
                disabled={!props.desdeAuditar ||
                  solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE || (
                    disabledProp && parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA
                  )}
                onChange={(e) => {
                  dispatch(
                    setearValorEnPractica(
                      props.practica?.idCodNom,
                      "recuperoSur",
                      e.target.checked
                    )
                  );
                }}
              />
            }
            label="SURGE"
          />
        </FormGroup>
        {props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO &&
          props.practica?.nroAutorizacion &&
          <PracticaNroAutorizacion
            domiciliaria={true}
            nroAutorizacion={props.practica?.nroAutorizacion}
          />
        }
      </>
      <AutorizacionesAccordionEfector
        idTipoEfector={
          AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL
        }
        practica={props.practica}
        disabled={((solicitudSeleccionada?.idEstadoSolicitud ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA || !props.permisoIngresoInterDom) && !props.permiteAgregarPracticaPeriodo)}
        preEfector={
          props?.practica?.efectorFacturacion?.cuit
            ?
            {
              efectorFacturacionRazonSocial: props?.practica?.efectorFacturacion?.razonSocial,
              efectorFacturacionCuit: props?.practica?.efectorFacturacion?.cuit
            }
            :
            null
        }
        desdeAuditar={props.desdeAuditar}
        emailEfectorI={props.practica.emailEfectorI}
        celularEfectorI={props.practica.celularEfectorI}
        emailEfectorIError={props.practica.emailEfectorIError}
        celularEfectorIError={props.practica.celularEfectorIError}
        setearEfector={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica?.idCodNom,
              "idEfectorFacturacion",
              idEfector
            )
          );
        }}
        setearEfectorP={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica?.idCodNom,
              "idCartillaPrestador",
              idEfector
            )
          );
        }}
        setearContactoEfectorI={props.handleInputContactosEfectorIChange}
        setearCopiarEfectorF={(value) => {
          dispatch(
            setearValorEnPractica(
              props.practica.idCodNom,
              "copiaEfectorInstitucional",
              value
            )
          );
        }}
        conInternacion={props.conInternacion}
        traerEfectores={getEfectorInstitucional}
        estaCorrecto={props.tieneEfectorInstitucional}
        esDenunciaInternacion={props.esDenunciaInternacion}
        showZonaLocalidad={false}
      />
      <AutorizacionesAccordionPrescriptor
        disabled={((solicitudSeleccionada?.idEstadoSolicitud ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA || !props.permisoIngresoInterDom) && !props.permiteAgregarPracticaPeriodo)}
        prePrescriptor={
          !!props.practica.idPrescriptor ? props.practica.prescriptor : null
        }
        setearEfector={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica.idCodNom,
              "idPrescriptor",
              idEfector
            )
          );
        }}
        estaCorrecto={props.tieneIdPrescriptor}
        esDenunciaInternacion={props.esDenunciaInternacion}
        practica={props.practica}
      />
      {props.mostrarMateriales && (
        <AutorizacionesAccordionMateriales
          practica={props.practica}
          disabled={props.disabled && !props.permiteAgregarPracticaPeriodo}
          desdeAuditar={props.desdeAuditar}
          estaCorrecto={props.tieneMinimoUnMaterial}
          esDenunciaInternacion={props.esDenunciaInternacion}
          idTipoSolicitud={solicitudSeleccionada?.idTipoSolicitud}
          evaluarPracticasMateriales={props.evaluarPracticasMateriales}
          permiteAgregarPracticaPeriodo={props.permiteAgregarPracticaPeriodo}
          permisoIngresoInterDom={props.permisoIngresoInterDom}
        />
      )}
    </div>
  );
};

export default PracticaTipoInternacionDomiciliaria;
